import { unsafeCoerce } from 'fp-ts/lib/function';
import { TrackingEvent } from '../../common/AnalyticsContext/TrackingEvent';
import { useAnalytics } from '../../common/AnalyticsContext/useAnalytics';
import { useEffectOnceOnCondition } from '../../common/hooks/useEffectOnceOnCondition';
import { Braze } from '../../common/vendors/braze/BrazeContext';
import { useBraze } from '../../common/vendors/braze/useBraze';

export const useTrackMediaAds = () => {
  const braze = useBraze();
  const { trackEvent } = useAnalytics();

  useEffectOnceOnCondition(braze !== null, () => {
    braze?.subscribeToInAppMessage((message: Braze.InAppMessage | Braze.ControlMessage) => {
      const brazeMessage: Braze.InAppMessage = unsafeCoerce(message);

      const mediaType: string = unsafeCoerce(brazeMessage.extras['mediaType'] ?? '');

      if (brazeMessage.message && mediaType === 'OPI') {
        const partner: string = unsafeCoerce(brazeMessage.extras['partner'] ?? '');

        trackEvent(TrackingEvent.MEDIA_AD_DISPLAYED, {
          partnerData: {
            opi: {
              slideIn: {
                displayed: true,
                question: brazeMessage.message,
                partner: partner,
              },
            },
          },
        });
      }
    });
  });
};
